import { CloudDownload } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { observer } from "mobx-react-lite";
import { downloadManager } from "../../../services/download/DownloadManagerService";

function getActivityName(activityType: ActivityTypes): string {
  switch (activityType) {
    case ActivityTypes.VideoAnalysis: return "VideoAnalysis";
    case ActivityTypes.HighlightDetection: return "VideoSegmentation";
    case ActivityTypes.VideoConversion: return "VideoConversion";
    case ActivityTypes.VideoOcr: return "InspectionInsights";
    case ActivityTypes.VideoAnalysisAndSegmentation: return "AnalysisAndSegmentation";
    case ActivityTypes.VideoOcrAndAnalysis: return "AnalysisAndInspectionInsights";
    default: return "Backup";
  }
}

export default observer(function DownloadMetadataButton({ fileId, activityType, videoName, disabled }: { fileId?: number, activityType: ActivityTypes[], videoName?: string, disabled: boolean }) {
  const { themeClass } = useThemeService();

  const download = () => {
    const raw = videoName?.replace(/\.[^/.]+$/, "") ?? String(fileId);
    // Strip filename-unsafe characters (Windows + Unix) and collapse whitespace
    // so a Haltung value like "200 23/27" doesn't break the download.
    const name = raw.replace(/[<>:"/\\|?*\x00-\x1F]/g, "_").replace(/\s+/g, "_").trim() || String(fileId);
    const activity = getActivityName(activityType[0]);
    const fileName = `${fileId}_${name}_${activity}.zip`;

    downloadManager.startBackupDownload(
      fileId!,
      activityType[0],
      fileName
    );
  };

  return (
    <Button
      id="metadata"
      onClick={download}
      disabled={disabled}
      icon={{
        svg: CloudDownload,
        textKey: "general.export.metadata",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-mui"]),
      }}
    />
  );
});
